import React, { useContext, useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { VibratoClientContext } from "./contexts"

const CampaignList: React.FC = () => {
  // const user = useContext(UserContext)
  // const upgradeModal = useContext(UpgradeModalContext)
  const [campaigns, setCampaigns] = useState([])
  const vibratoClient = useContext(VibratoClientContext)
  const navigate = useNavigate()

  useEffect(() => {
    document.title = "Vibrato - Campaigns"
  }, [])

  useEffect(() => {
    const fetchCampaigns = async () => {
      if (vibratoClient) {
        try {
          const fetchedCampaigns = await vibratoClient.getCampaigns()
          setCampaigns(fetchedCampaigns)
        } catch (error) {
          console.error("Failed to fetch campaigns:", error)
        }
      }
    }

    fetchCampaigns()
  }, [vibratoClient])

  const onClick = () => {
    // if (user.plan == "freemium") {
    //   upgradeModal.setShowModal(true)
    //   return
    // }

    navigate("/campaigns/new")
  }

  return (
    <div className="h-full p-8 flex flex-col gap-4 ">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Campaigns</h1>
        <button
          className="bg-green-400 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-lg w-fit"
          onClick={() => onClick()}
        >
          <span className="hidden sm:inline">Create Campaign</span>
          <span className="sm:hidden">Create</span>
        </button>
      </div>
      <div className="font-thin flex flex-col gap-2">
        <p>
          Campaigns automate the process of calling a group of contacts. Each campaign is associated with a task
          template, which defines the phone call that will be made to each contact in the campaign. A campaign can be
          scheduled to run at a specific times. Use campaigns to automate hundreds or thousands of phone calls.
        </p>
      </div>
      <div className="flex flex-col max-h-full bg-white shadow-md rounded-lg">
        <div className="grow overflow-auto rounded-lg">
          <table className="max-h-full w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-4 py-3">
                  Campaign Name
                </th>
                <th scope="col" className="px-4 py-3 hidden sm:table-cell">
                  Task Template
                </th>
                <th scope="col" className="px-4 py-3" />
              </tr>
            </thead>
            <tbody>
              {campaigns.map((campaign: any) => (
                <tr key={campaign.uuid} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    {campaign.name}
                  </td>
                  <td className="px-4 py-3 hidden sm:table-cell">{campaign.task_template.taskName}</td>
                  <td className="flex gap-2 justify-end px-4 py-3 text-right">
                    <Link to={`/campaigns/${campaign.uuid}`}>
                      <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded">
                        View
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {campaigns.length === 0 && (
          <div className="flex justify-center items-center h-[80px] bg-gray-50 rounded-lg">
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">No campaigns found.</span>
          </div>
        )}
        {/* Pagination or other controls could be added here */}
      </div>
    </div>
  )
}

export default CampaignList
